import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import './styles';

// const MAP_LEGEND = [
//   {
//     city: 'SAN FRANCISCO, CA',
//     description: 'Headquarters',
//     dot: require('./SF dot.png'),
//   },
//   {
//     city: 'FRESNO, CA',
//     description: 'Production Facility',
//     dot: require('./Fresno Dot.png'),
//   },
//   {
//     city: 'INDIANAPOLIS, IN',
//     description: 'Production Facility',
//     dot: require('./Indianapolis Dot.png'),
//   },
//   {
//     city: 'FREMONT, CA',
//     description: 'Administrative Offices',
//     dot: require('./Fremont Dot.png'),
//   },
//   {
//     city: 'DALLAS, TX',
//     description: 'Production Facility',
//     dot: require('./Dallas Dot.png'),
//   },
//   {
//     city: 'SCRANTON, PA',
//     description: 'Production Facility',
//     dot: require('./Scranton Dot.png'),
//   },
// ];

export default class NationalProduction extends React.Component {
  static propTypes = {
  }

  state = {}

  render() {
    return (
      <div className="NationalProduction">
        <div className="ui divider section-border m-v-0 computer-only" />
        <div className="p-v-2 computer-only" />
        <div className="p-v-2 computer-only" />
        <div className="p-v-2 computer-only" />
        <div className="ui container">
          <h1 className="m-b-2 center-aligned">
            NATIONALLY DISTRIBUTED PRODUCTION
          </h1>
          <div className="p-b-0_5" />
          <img className="mapImage" src={require('./production-map.png')} alt="production_map" />
          <div className="ui center aligned grid mapLegend">
            <p className="mapLocations">Indianapolis, IN  •  Coppell, TX</p>
          </div>
        </div>
        <div className="p-v-2" />
        <div className="p-v-2 computer-only" />
        <div className="p-v-2 computer-only" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/HomePage2/NationalProduction/index.jsx